var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-container"},[_c('div',{staticClass:"admin-header"},[_c('h1',{staticClass:"admin-title"},[_c('v-icon',{staticClass:"title-icon"},[_vm._v(_vm._s(_vm.pageIcon))]),_vm._v(" "+_vm._s(_vm.pageName)+" ")],1)]),_c('div',{staticClass:"admin-content"},[_c('PageTabs',{attrs:{"tabs":_vm.tabs,"startTab":_vm.tabFromQuery}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }